import { Button } from "@mantine/core";
//import { Edit, Trash } from "tabler-icons-react";

import {
  BINGO_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS,
  BINGO_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES,
} from "_roles";

import { AccessRights } from "common/admin/auth/AccessRights";

import { BingoGame } from "bingo/types/bingo-game.model";

export function BingoGameAdminRow({
  bingoGame,
  onEdit,
  onDelete,
}: {
  bingoGame: BingoGame;
  onEdit: () => void;
  onDelete: () => void;
}) {
  return (
    <tr>
      <td>{bingoGame.name}</td>
      <AccessRights
        authorizedOrganizations={
          BINGO_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS
        }
        authorizedRoles={BINGO_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES}
      >
        <td className="max-w-2">{bingoGame.access.organization}</td>
      </AccessRights>
      <td>
        {new Date(Date.parse(bingoGame.creationTime)).toLocaleString(
          undefined,
          {
            dateStyle: "short",
            timeStyle: "short",
          },
        )}
      </td>
      <td className="min-w-4">
        <div className="flex">
          <Button
            onClick={onEdit}
            className="bg-button-admin disabled:opacity-75"
          >
            Manage
          </Button>
          {/* <ActionIcon onClick={onEdit}>
            <Edit color="blue" size={20} />
          </ActionIcon>
          <ActionIcon onClick={onDelete}>
            <Trash color="red" size={20} />
          </ActionIcon> */}
        </div>
      </td>
    </tr>
  );
}
